import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * "Hoje" / "Ontem" / "12/09/2026" pill between two days of a thread, with a
 * hairline on both sides (Velzon `.chat-day-title`). `variant="unread"` is the
 * "Não lidas" marker inserted above the first message the user has not seen.
 */
@Component({
  selector: 'chat-day-separator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
<div class="chat-day" [class.chat-day--unread]="variant === 'unread'" role="separator" [attr.aria-label]="label">
  <span class="chat-day__line"></span>
  <span class="chat-day__pill">{{ label }}</span>
  <span class="chat-day__line"></span>
</div>`,
  styles: [`
:host { display: block; }
.chat-day { display: flex; align-items: center; gap: 12px; padding: 4px 0; }
.chat-day__line { flex-grow: 1; height: 1px; background: var(--chat-line); }
.chat-day__pill { font-size: 11px; font-weight: 500; color: var(--chat-muted); background: var(--chat-surface); border: 1px solid var(--chat-line); border-radius: 10px; padding: 2px 10px; white-space: nowrap; }
.chat-day--unread .chat-day__line { background: rgba(var(--chat-danger-rgb), .45); }
.chat-day--unread .chat-day__pill { color: var(--chat-danger); border-color: rgba(var(--chat-danger-rgb), .45); background: rgba(var(--chat-danger-rgb), .08); font-weight: 600; }
`]
})
export class ChatDaySeparatorComponent {
  @Input() label = '';
  @Input() variant: 'day' | 'unread' = 'day';
}
